import { DocumentParserAdapter } from './DocumentParser.mjs'
export class DocumentParserAdapterAzureDocumentAnalysis extends DocumentParserAdapter {
  constructor (client, options) {
    super(options)
    this.client = client
    this.options = options
  }

  async parse (base64) {
    const buffer = Buffer.from(base64, { encoding: 'base64' })
    const poller = await this.client.beginAnalyzeDocument(this.options.model, buffer)
    return await poller.pollUntilDone()
  }
}
